// Resolve 输出扩展名由 preset 决定；只按最后一个点拆分，支持基名自身包含帧率小数点。
export const isRenderOutputFileName = (fileName: string, renderFileName: string): boolean => {
  const dot = fileName.lastIndexOf('.')
  return dot > 0 && dot < fileName.length - 1 && fileName.slice(0, dot) === renderFileName
}
